module.exports = __webpack_public_path__ + "static/media/schools_blue.1022d3ab.svg";